import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { GlobalStyles, getPalette, getShadows, themeOptions } from '@/core/theme';
import { StyledEngineProvider, ThemeProvider, createTheme } from '@mui/material/styles';
import { Suspense, forwardRef, useMemo } from 'react';
import { ConfirmDialogProvider as ConfirmDialogProviderV2, SimpleSnackbar } from '@/shared/components';
import { ConfirmationDialog } from '@/shared/components/ConfirmDialog/components';
import { useLayoutStore } from '@/shared/modules/layout/business';
import CssBaseline from '@mui/material/CssBaseline';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { ruRU } from '@mui/x-date-pickers/locales';
import { ru } from 'date-fns/locale/ru';
import { setDefaultOptions } from 'date-fns/setDefaultOptions';
import { SnackbarProvider } from 'notistack';
import { RouterProvider } from 'react-router-dom';
import { router } from './navigation';
setDefaultOptions({ locale: ru });
const russianLocaleText = ruRU.components.MuiLocalizationProvider.defaultProps.localeText;
export const App = () => {
    const paletteMode = useLayoutStore((state) => state.paletteMode);
    const theme = useMemo(() => {
        const currentPalette = getPalette(paletteMode);
        const shadows = getShadows(currentPalette);
        return createTheme({
            ...themeOptions,
            palette: currentPalette,
            shadows: shadows,
            // colorSchemes: { light: true, dark: true },
            cssVariables: {
                cssVarPrefix: 'gp',
            },
        });
    }, [paletteMode]);
    return (_jsx(_Fragment, { children: _jsx(LocalizationProvider, { dateAdapter: AdapterDateFns, adapterLocale: ru, localeText: russianLocaleText, children: _jsx(StyledEngineProvider, { injectFirst: true, children: _jsxs(ThemeProvider, { noSsr: true, theme: theme, disableTransitionOnChange: false, children: [_jsx(CssBaseline, {}), _jsx(GlobalStyles, { theme: theme }), _jsx(SnackbarProvider, { anchorOrigin: { horizontal: 'right', vertical: 'bottom' }, Components: {
                                default: SimpleSnackbar,
                                success: SimpleSnackbar,
                                info: SimpleSnackbar,
                                warning: SimpleSnackbar,
                                error: SimpleSnackbar,
                                reconnect: forwardRef((props, ref) => _jsx(SimpleSnackbar, { ref: ref, disableClose: true, ...props })),
                            } }), _jsx(Suspense, { fallback: _jsx(_Fragment, { children: "Loading..." }), children: _jsx(RouterProvider, { router: router }) }), _jsx(ConfirmDialogProviderV2, {}), _jsx(ConfirmationDialog, {})] }) }) }) }));
};
